module.exports = __webpack_public_path__ + "media/img/frontend_application/eventtype/dinner-050f0e24620e7ea01dbfa70049c3c32c.jpg";